import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const location = useLocation();

  const getActiveLanguage = () => {
    const match = document.cookie.match(/googtrans=\/en\/([a-z]{2})/);
    return match ? match[1] : 'en';
  };

  const handleLanguageChange = (e) => {
    const langCode = e.target.value;
    const domain = window.location.hostname;
    document.cookie = `googtrans=/en/${langCode}; path=/;`;
    document.cookie = `googtrans=/en/${langCode}; path=/; domain=${domain};`;
    // Supprime pour les sous-domaines/localhost
    document.cookie = `googtrans=/en/${langCode}; path=/; domain=.${domain};`;
    window.location.reload();
  };

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/projects', label: 'Our Activities' },
    { path: '/programs', label: 'Our Programs' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    if (path === '/projects') {
      return location.pathname === '/projects' || location.pathname.startsWith('/articles/');
    }
    if (path === '/programs') {
      const isProjectDetail = location.pathname.startsWith('/projects/') && location.pathname !== '/projects';
      return location.pathname.startsWith('/programs') || isProjectDetail;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header>
      <div className="header-area">
        <div className="main-header">
          <div className="header-top d-none d-lg-block">
            <div className="container-fluid">
              <div className="col-xl-12">
                <div className="row d-flex justify-content-between align-items-center">
                  <div className="header-info-left d-flex">
                    <ul>     
                      <li>WhatsApp: 0048516160255</li>
                      <li>Email: contact.efis2025@gmail.com</li>
                    </ul>
                    <div className="header-social">    
                      <ul>
                        <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                         <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                      {/* <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>*/}
                      </ul>
                    </div>
                  </div>
                  <div className="header-info-right d-flex align-items-center">
                    <div className="select-this" style={{ marginRight: '15px' }}>
                      <div className="select-itms">
                        <select 
                          value={getActiveLanguage()} 
                          onChange={handleLanguageChange}
                          style={{
                            background: 'transparent',
                            color: '#002B5C',
                            border: '1px solid #cbd5e1',
                            borderRadius: '20px',
                            padding: '6px 15px',
                            fontSize: '13px',
                            cursor: 'pointer',
                            outline: 'none',
                            fontWeight: '700',
                            fontFamily: 'Inter, sans-serif'
                          }}
                        >
                          <option value="en">English (EN)</option>
                          <option value="pl">Polski (PL)</option>
                        </select>
                      </div>
                    </div>
                    <ul className="contact-now">     
                      <li><Link to="/contact">Join Us</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-bottom header-sticky">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-2">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/img/logo/logoefis.png" alt="EFIS Logo" style={{ maxHeight: '87px' }} />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-10 col-lg-10">
                  <div className="menu-wrapper d-flex align-items-center justify-content-end">
                    <div className="main-menu d-none d-lg-block">
                      <nav>
                        <ul id="navigation">
                          {navLinks.map((link) => (
                            <li key={link.path}>
                              <Link 
                                to={link.path}
                                className={isActive(link.path) ? 'active-link' : ''}
                              >
                                {link.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>
                    <div className="header-right-btn d-none d-lg-block ml-20">
                      <Link to="/contact" className="btn header-btn">Get Involved</Link>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="mobile_menu d-block d-lg-none"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;